import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';
import Checkbox from 'react-toolbox/lib/checkbox';
import LocationPicker from '~/components/LocationPicker';
import MultiPicker from '~/components/MultiPicker';

const defaults = {
  orderStatus: 'Todo'
};

const fields = {
  locationIds: MultiPicker(LocationPicker)
};

class ProductionQueueSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState({ outdata: { ...this.state.outdata, [property]: value } }, this.onChange);
  }

  render() {
    const orderStatuses = [
      { value: 'Todo', label: 'Todo' },
      { value: 'Distributor', label: 'Distributor' }
    ];
    const Cmp = fields.locationIds;

    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <Dropdown
          onChange={val => this.setOutdataValue('orderStatus', val)}
          source={orderStatuses}
          value={this.state.outdata.orderStatus}
          label="Order status"
        />
        <Checkbox
          checked={this.state.outdata.skipInventory}
          label="Skip inventory in calculation"
          onChange={val => this.setOutdataValue('skipInventory', val)}
        />
        {!this.state.outdata.skipInventory && <Cmp
          value={this.state.outdata.locationIds}
          onChange={val => this.setOutdataValue('locationIds', val)}
        />}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null, null, { pure: false })(ProductionQueueSettings);



// WEBPACK FOOTER //
// ./app/widgets/ProductionQueue/settings.js